export const routerLinkWithLang = (url, lang) => {
  if (lang !== 'it') {
    return `/${lang}${url}`
  }
  return url
}